// extracted by mini-css-extract-plugin
module.exports = {"overlay":"l0wX8jEx9wszbp7FTDwoM"};